<geaui-page-layout-v3 [headerTemplate]="header" [contentTemplate]="content" [sidebarTemplate]="sidebar">
  <ng-template #header>
    <app-header></app-header>
  </ng-template>
  <ng-template #content>
    @if (!userLogin ||(spinnerService.loading$ | async)) {
    <div class="spinner">
      <p-progress-spinner animationDuration="2s" strokeWidth="4"></p-progress-spinner>
    </div>
    }

    <div class="content-body">
      <router-outlet></router-outlet>

    </div>
  </ng-template>
  <ng-template #sidebar>
    @if (userLogin) {
    <!-- <CHANGE ME> - Change to Icon of your Choice -->
    <geaui-sidebar-v3 [navigationItems]="navItems" [slimView]="true" [adminViewNavigationItems]="adminNavItems"
      [devisionIconPath]="'/assets/icons/GEA-NPE-Engineering-Portal-VB-sRGB.svg'" [bottomNavigation]="botItems"
      [devisionName]="title" devisionIconBackgroundColor="var(--geaui-night-blue)">
    </geaui-sidebar-v3>
    }
  </ng-template>
</geaui-page-layout-v3>